var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 74,
    viewBox: "0 0 106 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 88,
    height: 60,
    rx: 2,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 19,
    width: 11,
    height: 11,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 19,
    width: 11,
    height: 11,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 32,
    width: 11,
    height: 11,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 32,
    width: 11,
    height: 11,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40031 61.7196C8.7803 61.2636 9.34319 61 9.93675 61H96.0632C96.6568 61 97.2197 61.2636 97.5997 61.7196L104.266 69.7196C105.352 71.0223 104.426 73 102.73 73H3.27008C1.57441 73 0.648096 71.0223 1.73364 69.7196L8.40031 61.7196Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcons);
export default __webpack_public_path__ + "static/media/windows-icons.6df45dc8ad49035ac2e62298b5a0ebc6.svg";
export { ForwardRef as ReactComponent };